var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-view"},[_c('pre',[_vm._v(_vm._s(_vm.text))]),_c('md-button',{staticClass:"md-raised md-primary code-copy",on:{"click":_vm.copy}},[_c('md-icon',[_vm._v("content_copy")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }